import React from 'react';
import VideoPlayer from '../../common/video/VideoPlayer';

function VideoPlayerSection() {
  return (
    <div className="paper">
      <div className="styleguide__title">VideoPlayer</div>
      <div className="styleguide__row">
        <VideoPlayer
          title="Chapter 2, Day 18"
          poster="https://d27vybgvtr1dba.cloudfront.net/subscribe-thumbnail-1.jpg"
          initialTime={60}
          sections={[
            {
              startTime: 0,
              text: 'Stretching Movements Routine B',
            },
            {
              startTime: 40,
              text: 'Greatest Players Hands & Arms',
            },
            {
              startTime: 60,
              text: 'Mental Training Exercise',
            },
          ]}
          onProgress={currentTime => {}}
          onEnd={() => {}}
        >
          <source
            src="https://d27vybgvtr1dba.cloudfront.net/Q12B(3)+Brandel+Gary+Not+Gettting+Paid+No+In+Out.mp4"
            type="video/mp4"
          />
        </VideoPlayer>
      </div>
    </div>
  );
}

export default VideoPlayerSection;



// WEBPACK FOOTER //
// ./src/style-guide/sections/VideoPlayer.js